function c(e, t, n) {
  function r(s, a) {
    var h;
    Object.defineProperty(s, "_zod", {
      value: s._zod ?? {},
      enumerable: !1
    }), (h = s._zod).traits ?? (h.traits = /* @__PURE__ */ new Set()), s._zod.traits.add(e), t(s, a);
    for (const _ in i.prototype)
      _ in s || Object.defineProperty(s, _, { value: i.prototype[_].bind(s) });
    s._zod.constr = i, s._zod.def = a;
  }
  const o = (n == null ? void 0 : n.Parent) ?? Object;
  class u extends o {
  }
  Object.defineProperty(u, "name", { value: e });
  function i(s) {
    var a;
    const h = n != null && n.Parent ? new u() : this;
    r(h, s), (a = h._zod).deferred ?? (a.deferred = []);
    for (const _ of h._zod.deferred)
      _();
    return h;
  }
  return Object.defineProperty(i, "init", { value: r }), Object.defineProperty(i, Symbol.hasInstance, {
    value: (s) => {
      var a, h;
      return n != null && n.Parent && s instanceof n.Parent ? !0 : (h = (a = s == null ? void 0 : s._zod) == null ? void 0 : a.traits) == null ? void 0 : h.has(e);
    }
  }), Object.defineProperty(i, "name", { value: e }), i;
}
class D extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
const Ne = {};
function P(e) {
  return Ne;
}
function et(e) {
  const t = Object.values(e).filter((r) => typeof r == "number");
  return Object.entries(e).filter(([r, o]) => t.indexOf(+r) === -1).map(([r, o]) => o);
}
function tt(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Se(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function oe(e) {
  return e == null;
}
function ue(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
function nt(e, t) {
  const n = (e.toString().split(".")[1] || "").length, r = (t.toString().split(".")[1] || "").length, o = n > r ? n : r, u = Number.parseInt(e.toFixed(o).replace(".", "")), i = Number.parseInt(t.toFixed(o).replace(".", ""));
  return u % i / 10 ** o;
}
function z(e, t, n) {
  Object.defineProperty(e, t, {
    get() {
      {
        const r = n();
        return e[t] = r, r;
      }
    },
    set(r) {
      Object.defineProperty(e, t, {
        value: r
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function ie(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function Ae(e = 10) {
  const t = "abcdefghijklmnopqrstuvwxyz";
  let n = "";
  for (let r = 0; r < e; r++)
    n += t[Math.floor(Math.random() * t.length)];
  return n;
}
function C(e) {
  return JSON.stringify(e);
}
const Re = Error.captureStackTrace ? Error.captureStackTrace : (...e) => {
};
function ee(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const rt = Se(() => {
  var e;
  if (typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) != null && e.includes("Cloudflare")))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function te(e) {
  if (ee(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(ee(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
const ot = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Y(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function S(e, t, n) {
  const r = new e._zod.constr(t ?? e._zod.def);
  return (!t || n != null && n.parent) && (r._zod.parent = e), r;
}
function l(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if ((t == null ? void 0 : t.message) !== void 0) {
    if ((t == null ? void 0 : t.error) !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function ut(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const it = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function ct(e, t) {
  const n = {}, r = e._zod.def;
  for (const o in t) {
    if (!(o in r.shape))
      throw new Error(`Unrecognized key: "${o}"`);
    t[o] && (n[o] = r.shape[o]);
  }
  return S(e, {
    ...e._zod.def,
    shape: n,
    checks: []
  });
}
function st(e, t) {
  const n = { ...e._zod.def.shape }, r = e._zod.def;
  for (const o in t) {
    if (!(o in r.shape))
      throw new Error(`Unrecognized key: "${o}"`);
    t[o] && delete n[o];
  }
  return S(e, {
    ...e._zod.def,
    shape: n,
    checks: []
  });
}
function at(e, t) {
  const n = {
    ...e._zod.def,
    get shape() {
      const r = { ...e._zod.def.shape, ...t };
      return ie(this, "shape", r), r;
    },
    checks: []
    // delete existing checks
  };
  return S(e, n);
}
function lt(e, t) {
  return S(e, {
    ...e._zod.def,
    get shape() {
      const n = { ...e._zod.def.shape, ...t._zod.def.shape };
      return ie(this, "shape", n), n;
    },
    catchall: t._zod.def.catchall,
    checks: []
    // delete existing checks
  });
}
function ht(e, t, n) {
  const r = t._zod.def.shape, o = { ...r };
  if (n)
    for (const u in n) {
      if (!(u in r))
        throw new Error(`Unrecognized key: "${u}"`);
      n[u] && (o[u] = e ? new e({
        type: "optional",
        innerType: r[u]
      }) : r[u]);
    }
  else
    for (const u in r)
      o[u] = e ? new e({
        type: "optional",
        innerType: r[u]
      }) : r[u];
  return S(t, {
    ...t._zod.def,
    shape: o,
    checks: []
  });
}
function pt(e, t, n) {
  const r = t._zod.def.shape, o = { ...r };
  if (n)
    for (const u in n) {
      if (!(u in o))
        throw new Error(`Unrecognized key: "${u}"`);
      n[u] && (o[u] = new e({
        type: "nonoptional",
        innerType: r[u]
      }));
    }
  else
    for (const u in r)
      o[u] = new e({
        type: "nonoptional",
        innerType: r[u]
      });
  return S(t, {
    ...t._zod.def,
    shape: o,
    // optional: [],
    checks: []
  });
}
function j(e, t = 0) {
  for (let n = t; n < e.issues.length; n++)
    if (e.issues[n].continue !== !0)
      return !0;
  return !1;
}
function N(e, t) {
  return t.map((n) => {
    var r;
    return (r = n).path ?? (r.path = []), n.path.unshift(e), n;
  });
}
function V(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.message;
}
function O(e, t, n) {
  var o, u, i, s, a, h;
  const r = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const _ = V((i = (u = (o = e.inst) == null ? void 0 : o._zod.def) == null ? void 0 : u.error) == null ? void 0 : i.call(u, e)) ?? V((s = t == null ? void 0 : t.error) == null ? void 0 : s.call(t, e)) ?? V((a = n.customError) == null ? void 0 : a.call(n, e)) ?? V((h = n.localeError) == null ? void 0 : h.call(n, e)) ?? "Invalid input";
    r.message = _;
  }
  return delete r.inst, delete r.continue, t != null && t.reportInput || delete r.input, r;
}
function ce(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function U(...e) {
  const [t, n, r] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: r
  } : { ...t };
}
const xe = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), Object.defineProperty(e, "message", {
    get() {
      return JSON.stringify(t, tt, 2);
    },
    enumerable: !0
    // configurable: false,
  });
}, Ce = c("$ZodError", xe), je = c("$ZodError", xe, { Parent: Error });
function ft(e, t = (n) => n.message) {
  const n = {}, r = [];
  for (const o of e.issues)
    o.path.length > 0 ? (n[o.path[0]] = n[o.path[0]] || [], n[o.path[0]].push(t(o))) : r.push(t(o));
  return { formErrors: r, fieldErrors: n };
}
function dt(e, t) {
  const n = t || function(u) {
    return u.message;
  }, r = { _errors: [] }, o = (u) => {
    for (const i of u.issues)
      if (i.code === "invalid_union" && i.errors.length)
        i.errors.map((s) => o({ issues: s }));
      else if (i.code === "invalid_key")
        o({ issues: i.issues });
      else if (i.code === "invalid_element")
        o({ issues: i.issues });
      else if (i.path.length === 0)
        r._errors.push(n(i));
      else {
        let s = r, a = 0;
        for (; a < i.path.length; ) {
          const h = i.path[a];
          a === i.path.length - 1 ? (s[h] = s[h] || { _errors: [] }, s[h]._errors.push(n(i))) : s[h] = s[h] || { _errors: [] }, s = s[h], a++;
        }
      }
  };
  return o(e), r;
}
const _t = (e) => (t, n, r, o) => {
  const u = r ? Object.assign(r, { async: !1 }) : { async: !1 }, i = t._zod.run({ value: n, issues: [] }, u);
  if (i instanceof Promise)
    throw new D();
  if (i.issues.length) {
    const s = new ((o == null ? void 0 : o.Err) ?? e)(i.issues.map((a) => O(a, u, P())));
    throw Re(s, o == null ? void 0 : o.callee), s;
  }
  return i.value;
}, mt = (e) => async (t, n, r, o) => {
  const u = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let i = t._zod.run({ value: n, issues: [] }, u);
  if (i instanceof Promise && (i = await i), i.issues.length) {
    const s = new ((o == null ? void 0 : o.Err) ?? e)(i.issues.map((a) => O(a, u, P())));
    throw Re(s, o == null ? void 0 : o.callee), s;
  }
  return i.value;
}, De = (e) => (t, n, r) => {
  const o = r ? { ...r, async: !1 } : { async: !1 }, u = t._zod.run({ value: n, issues: [] }, o);
  if (u instanceof Promise)
    throw new D();
  return u.issues.length ? {
    success: !1,
    error: new (e ?? Ce)(u.issues.map((i) => O(i, o, P())))
  } : { success: !0, data: u.value };
}, vt = /* @__PURE__ */ De(je), Ue = (e) => async (t, n, r) => {
  const o = r ? Object.assign(r, { async: !0 }) : { async: !0 };
  let u = t._zod.run({ value: n, issues: [] }, o);
  return u instanceof Promise && (u = await u), u.issues.length ? {
    success: !1,
    error: new e(u.issues.map((i) => O(i, o, P())))
  } : { success: !0, data: u.value };
}, gt = /* @__PURE__ */ Ue(je), zt = /^[cC][^\s-]{8,}$/, bt = /^[0-9a-z]+$/, wt = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, Zt = /^[0-9a-vA-V]{20}$/, kt = /^[A-Za-z0-9]{27}$/, $t = /^[a-zA-Z0-9_-]{21}$/, yt = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, It = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, he = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000)$/, Et = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Tt = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function Pt() {
  return new RegExp(Tt, "u");
}
const Ot = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Nt = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})$/, St = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, At = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Rt = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, Fe = /^[A-Za-z0-9_-]*$/, xt = /^([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+$/, Ct = /^\+(?:[0-9]){6,14}[0-9]$/, Le = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", jt = /* @__PURE__ */ new RegExp(`^${Le}$`);
function Me(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Dt(e) {
  return new RegExp(`^${Me(e)}$`);
}
function Ut(e) {
  const t = Me({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-]\\d{2}:\\d{2})");
  const r = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${Le}T(?:${r})$`);
}
const Ft = (e) => {
  const t = e ? `[\\s\\S]{${(e == null ? void 0 : e.minimum) ?? 0},${(e == null ? void 0 : e.maximum) ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, Lt = /^\d+$/, Mt = /^-?\d+(?:\.\d+)?/i, Vt = /true|false/i, Wt = /^[^A-Z]*$/, Bt = /^[^a-z]*$/, I = /* @__PURE__ */ c("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), Ve = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, We = /* @__PURE__ */ c("$ZodCheckLessThan", (e, t) => {
  I.init(e, t);
  const n = Ve[typeof t.value];
  e._zod.onattach.push((r) => {
    const o = r._zod.bag, u = (t.inclusive ? o.maximum : o.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < u && (t.inclusive ? o.maximum = t.value : o.exclusiveMaximum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
      origin: n,
      code: "too_big",
      maximum: t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Be = /* @__PURE__ */ c("$ZodCheckGreaterThan", (e, t) => {
  I.init(e, t);
  const n = Ve[typeof t.value];
  e._zod.onattach.push((r) => {
    const o = r._zod.bag, u = (t.inclusive ? o.minimum : o.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > u && (t.inclusive ? o.minimum = t.value : o.exclusiveMinimum = t.value);
  }), e._zod.check = (r) => {
    (t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
      origin: n,
      code: "too_small",
      minimum: t.value,
      input: r.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Gt = /* @__PURE__ */ c("$ZodCheckMultipleOf", (e, t) => {
  I.init(e, t), e._zod.onattach.push((n) => {
    var r;
    (r = n._zod.bag).multipleOf ?? (r.multipleOf = t.value);
  }), e._zod.check = (n) => {
    if (typeof n.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : nt(n.value, t.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Kt = /* @__PURE__ */ c("$ZodCheckNumberFormat", (e, t) => {
  var i;
  I.init(e, t), t.format = t.format || "float64";
  const n = (i = t.format) == null ? void 0 : i.includes("int"), r = n ? "int" : "number", [o, u] = it[t.format];
  e._zod.onattach.push((s) => {
    const a = s._zod.bag;
    a.format = t.format, a.minimum = o, a.maximum = u, n && (a.pattern = Lt);
  }), e._zod.check = (s) => {
    const a = s.value;
    if (n) {
      if (!Number.isInteger(a)) {
        s.issues.push({
          expected: r,
          format: t.format,
          code: "invalid_type",
          input: a,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(a)) {
        a > 0 ? s.issues.push({
          input: a,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: r,
          continue: !t.abort
        }) : s.issues.push({
          input: a,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: r,
          continue: !t.abort
        });
        return;
      }
    }
    a < o && s.issues.push({
      origin: "number",
      input: a,
      code: "too_small",
      minimum: o,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), a > u && s.issues.push({
      origin: "number",
      input: a,
      code: "too_big",
      maximum: u,
      inst: e
    });
  };
}), Jt = /* @__PURE__ */ c("$ZodCheckMaxLength", (e, t) => {
  I.init(e, t), e._zod.when = (n) => {
    const r = n.value;
    return !oe(r) && r.length !== void 0;
  }, e._zod.onattach.push((n) => {
    const r = n._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < r && (n._zod.bag.maximum = t.maximum);
  }), e._zod.check = (n) => {
    const r = n.value;
    if (r.length <= t.maximum)
      return;
    const u = ce(r);
    n.issues.push({
      origin: u,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: r,
      inst: e,
      continue: !t.abort
    });
  };
}), Yt = /* @__PURE__ */ c("$ZodCheckMinLength", (e, t) => {
  I.init(e, t), e._zod.when = (n) => {
    const r = n.value;
    return !oe(r) && r.length !== void 0;
  }, e._zod.onattach.push((n) => {
    const r = n._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > r && (n._zod.bag.minimum = t.minimum);
  }), e._zod.check = (n) => {
    const r = n.value;
    if (r.length >= t.minimum)
      return;
    const u = ce(r);
    n.issues.push({
      origin: u,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: r,
      inst: e,
      continue: !t.abort
    });
  };
}), Xt = /* @__PURE__ */ c("$ZodCheckLengthEquals", (e, t) => {
  I.init(e, t), e._zod.when = (n) => {
    const r = n.value;
    return !oe(r) && r.length !== void 0;
  }, e._zod.onattach.push((n) => {
    const r = n._zod.bag;
    r.minimum = t.length, r.maximum = t.length, r.length = t.length;
  }), e._zod.check = (n) => {
    const r = n.value, o = r.length;
    if (o === t.length)
      return;
    const u = ce(r), i = o > t.length;
    n.issues.push({
      origin: u,
      ...i ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), X = /* @__PURE__ */ c("$ZodCheckStringFormat", (e, t) => {
  var n;
  I.init(e, t), e._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.format = t.format, t.pattern && (o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(t.pattern));
  }), (n = e._zod).check ?? (n.check = (r) => {
    if (!t.pattern)
      throw new Error("Not implemented.");
    t.pattern.lastIndex = 0, !t.pattern.test(r.value) && r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: r.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  });
}), qt = /* @__PURE__ */ c("$ZodCheckRegex", (e, t) => {
  X.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), Ht = /* @__PURE__ */ c("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = Wt), X.init(e, t);
}), Qt = /* @__PURE__ */ c("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = Bt), X.init(e, t);
}), en = /* @__PURE__ */ c("$ZodCheckIncludes", (e, t) => {
  I.init(e, t);
  const n = Y(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = r, e._zod.onattach.push((o) => {
    const u = o._zod.bag;
    u.patterns ?? (u.patterns = /* @__PURE__ */ new Set()), u.patterns.add(r);
  }), e._zod.check = (o) => {
    o.value.includes(t.includes, t.position) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), tn = /* @__PURE__ */ c("$ZodCheckStartsWith", (e, t) => {
  I.init(e, t);
  const n = new RegExp(`^${Y(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.startsWith(t.prefix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), nn = /* @__PURE__ */ c("$ZodCheckEndsWith", (e, t) => {
  I.init(e, t);
  const n = new RegExp(`.*${Y(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((r) => {
    const o = r._zod.bag;
    o.patterns ?? (o.patterns = /* @__PURE__ */ new Set()), o.patterns.add(n);
  }), e._zod.check = (r) => {
    r.value.endsWith(t.suffix) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), rn = /* @__PURE__ */ c("$ZodCheckOverwrite", (e, t) => {
  I.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class on {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const r = t.split(`
`).filter((i) => i), o = Math.min(...r.map((i) => i.length - i.trimStart().length)), u = r.map((i) => i.slice(o)).map((i) => " ".repeat(this.indent * 2) + i);
    for (const i of u)
      this.content.push(i);
  }
  compile() {
    const t = Function, n = this == null ? void 0 : this.args, o = [...((this == null ? void 0 : this.content) ?? [""]).map((u) => `  ${u}`)];
    return new t(...n, o.join(`
`));
  }
}
const un = {
  major: 4,
  minor: 0,
  patch: 0
}, b = /* @__PURE__ */ c("$ZodType", (e, t) => {
  var o;
  var n;
  e ?? (e = {}), z(e._zod, "id", () => t.type + "_" + Ae(10)), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = un;
  const r = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && r.unshift(e);
  for (const u of r)
    for (const i of u._zod.onattach)
      i(e);
  if (r.length === 0)
    (n = e._zod).deferred ?? (n.deferred = []), (o = e._zod.deferred) == null || o.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const u = (i, s, a) => {
      let h = j(i), _;
      for (const p of s) {
        if (p._zod.when) {
          if (!p._zod.when(i))
            continue;
        } else if (h)
          continue;
        const f = i.issues.length, v = p._zod.check(i);
        if (v instanceof Promise && (a == null ? void 0 : a.async) === !1)
          throw new D();
        if (_ || v instanceof Promise)
          _ = (_ ?? Promise.resolve()).then(async () => {
            await v, i.issues.length !== f && (h || (h = j(i, f)));
          });
        else {
          if (i.issues.length === f)
            continue;
          h || (h = j(i, f));
        }
      }
      return _ ? _.then(() => i) : i;
    };
    e._zod.run = (i, s) => {
      const a = e._zod.parse(i, s);
      if (a instanceof Promise) {
        if (s.async === !1)
          throw new D();
        return a.then((h) => u(h, r, s));
      }
      return u(a, r, s);
    };
  }
  e["~standard"] = {
    validate: (u) => {
      var i;
      try {
        const s = vt(e, u);
        return s.success ? { value: s.data } : { issues: (i = s.error) == null ? void 0 : i.issues };
      } catch {
        return gt(e, u).then((a) => {
          var h;
          return a.success ? { value: a.data } : { issues: (h = a.error) == null ? void 0 : h.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  };
}), se = /* @__PURE__ */ c("$ZodString", (e, t) => {
  var n;
  b.init(e, t), e._zod.pattern = [...((n = e == null ? void 0 : e._zod.bag) == null ? void 0 : n.patterns) ?? []].pop() ?? Ft(e._zod.bag), e._zod.parse = (r, o) => {
    if (t.coerce)
      try {
        r.value = String(r.value);
      } catch {
      }
    return typeof r.value == "string" || r.issues.push({
      expected: "string",
      code: "invalid_type",
      input: r.value,
      inst: e
    }), r;
  };
}), m = /* @__PURE__ */ c("$ZodStringFormat", (e, t) => {
  X.init(e, t), se.init(e, t);
}), cn = /* @__PURE__ */ c("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = It), m.init(e, t);
}), sn = /* @__PURE__ */ c("$ZodUUID", (e, t) => {
  if (t.version) {
    const r = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (r === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = he(r));
  } else
    t.pattern ?? (t.pattern = he());
  m.init(e, t);
}), an = /* @__PURE__ */ c("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = Et), m.init(e, t);
}), ln = /* @__PURE__ */ c("$ZodURL", (e, t) => {
  m.init(e, t), e._zod.check = (n) => {
    try {
      const r = new URL(n.value);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(r.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: xt.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(r.protocol.endsWith(":") ? r.protocol.slice(0, -1) : r.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      }));
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), hn = /* @__PURE__ */ c("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = Pt()), m.init(e, t);
}), pn = /* @__PURE__ */ c("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = $t), m.init(e, t);
}), fn = /* @__PURE__ */ c("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = zt), m.init(e, t);
}), dn = /* @__PURE__ */ c("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = bt), m.init(e, t);
}), _n = /* @__PURE__ */ c("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = wt), m.init(e, t);
}), mn = /* @__PURE__ */ c("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = Zt), m.init(e, t);
}), vn = /* @__PURE__ */ c("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = kt), m.init(e, t);
}), gn = /* @__PURE__ */ c("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = Ut(t)), m.init(e, t), e._zod.check;
}), zn = /* @__PURE__ */ c("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = jt), m.init(e, t);
}), bn = /* @__PURE__ */ c("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = Dt(t)), m.init(e, t), e._zod.check;
}), wn = /* @__PURE__ */ c("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = yt), m.init(e, t);
}), Zn = /* @__PURE__ */ c("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = Ot), m.init(e, t), e._zod.onattach.push((n) => {
    const r = n._zod.bag;
    r.format = "ipv4";
  });
}), kn = /* @__PURE__ */ c("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = Nt), m.init(e, t), e._zod.onattach.push((n) => {
    const r = n._zod.bag;
    r.format = "ipv6";
  }), e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), $n = /* @__PURE__ */ c("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = St), m.init(e, t);
}), yn = /* @__PURE__ */ c("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = At), m.init(e, t), e._zod.check = (n) => {
    const [r, o] = n.value.split("/");
    try {
      if (!o)
        throw new Error();
      const u = Number(o);
      if (`${u}` !== o)
        throw new Error();
      if (u < 0 || u > 128)
        throw new Error();
      new URL(`http://[${r}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function Ge(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const In = /* @__PURE__ */ c("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = Rt), m.init(e, t), e._zod.onattach.push((n) => {
    n._zod.bag.contentEncoding = "base64";
  }), e._zod.check = (n) => {
    Ge(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function En(e) {
  if (!Fe.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (r) => r === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return Ge(n);
}
const Tn = /* @__PURE__ */ c("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = Fe), m.init(e, t), e._zod.onattach.push((n) => {
    n._zod.bag.contentEncoding = "base64url";
  }), e._zod.check = (n) => {
    En(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Pn = /* @__PURE__ */ c("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = Ct), m.init(e, t);
});
function On(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [r] = n, o = JSON.parse(atob(r));
    return !("typ" in o && (o == null ? void 0 : o.typ) !== "JWT" || !o.alg || t && (!("alg" in o) || o.alg !== t));
  } catch {
    return !1;
  }
}
const Nn = /* @__PURE__ */ c("$ZodJWT", (e, t) => {
  m.init(e, t), e._zod.check = (n) => {
    On(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Ke = /* @__PURE__ */ c("$ZodNumber", (e, t) => {
  b.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? Mt, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const o = n.value;
    if (typeof o == "number" && !Number.isNaN(o) && Number.isFinite(o))
      return n;
    const u = typeof o == "number" ? Number.isNaN(o) ? "NaN" : Number.isFinite(o) ? void 0 : "Infinity" : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: o,
      inst: e,
      ...u ? { received: u } : {}
    }), n;
  };
}), Sn = /* @__PURE__ */ c("$ZodNumber", (e, t) => {
  Kt.init(e, t), Ke.init(e, t);
}), An = /* @__PURE__ */ c("$ZodBoolean", (e, t) => {
  b.init(e, t), e._zod.pattern = Vt, e._zod.parse = (n, r) => {
    if (t.coerce)
      try {
        n.value = !!n.value;
      } catch {
      }
    const o = n.value;
    return typeof o == "boolean" || n.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: o,
      inst: e
    }), n;
  };
}), Rn = /* @__PURE__ */ c("$ZodUnknown", (e, t) => {
  b.init(e, t), e._zod.parse = (n) => n;
}), xn = /* @__PURE__ */ c("$ZodNever", (e, t) => {
  b.init(e, t), e._zod.parse = (n, r) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
});
function pe(e, t, n) {
  e.issues.length && t.issues.push(...N(n, e.issues)), t.value[n] = e.value;
}
const Cn = /* @__PURE__ */ c("$ZodArray", (e, t) => {
  b.init(e, t), e._zod.parse = (n, r) => {
    const o = n.value;
    if (!Array.isArray(o))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: o,
        inst: e
      }), n;
    n.value = Array(o.length);
    const u = [];
    for (let i = 0; i < o.length; i++) {
      const s = o[i], a = t.element._zod.run({
        value: s,
        issues: []
      }, r);
      a instanceof Promise ? u.push(a.then((h) => pe(h, n, i))) : pe(a, n, i);
    }
    return u.length ? Promise.all(u).then(() => n) : n;
  };
});
function W(e, t, n) {
  e.issues.length && t.issues.push(...N(n, e.issues)), t.value[n] = e.value;
}
function fe(e, t, n, r) {
  e.issues.length ? r[n] === void 0 ? n in r ? t.value[n] = void 0 : t.value[n] = e.value : t.issues.push(...N(n, e.issues)) : e.value === void 0 ? n in r && (t.value[n] = void 0) : t.value[n] = e.value;
}
const jn = /* @__PURE__ */ c("$ZodObject", (e, t) => {
  b.init(e, t);
  const n = Se(() => {
    const p = Object.keys(t.shape);
    for (const v of p)
      if (!(t.shape[v] instanceof b))
        throw new Error(`Invalid element at key "${v}": expected a Zod schema`);
    const f = ut(t.shape);
    return {
      shape: t.shape,
      keys: p,
      keySet: new Set(p),
      numKeys: p.length,
      optionalKeys: new Set(f)
    };
  });
  z(e._zod, "propValues", () => {
    const p = t.shape, f = {};
    for (const v in p) {
      const y = p[v]._zod;
      if (y.values) {
        f[v] ?? (f[v] = /* @__PURE__ */ new Set());
        for (const E of y.values)
          f[v].add(E);
      }
    }
    return f;
  });
  const r = (p) => {
    const f = new on(["shape", "payload", "ctx"]), { keys: v, optionalKeys: y } = n.value, E = ($) => {
      const g = C($);
      return `shape[${g}]._zod.run({ value: input[${g}], issues: [] }, ctx)`;
    };
    f.write("const input = payload.value;");
    const R = /* @__PURE__ */ Object.create(null);
    for (const $ of v)
      R[$] = Ae(15);
    f.write("const newResult = {}");
    for (const $ of v)
      if (y.has($)) {
        const g = R[$];
        f.write(`const ${g} = ${E($)};`);
        const k = C($);
        f.write(`
        if (${g}.issues.length) {
          if (input[${k}] === undefined) {
            if (${k} in input) {
              newResult[${k}] = undefined;
            }
          } else {
            payload.issues = payload.issues.concat(
              ${g}.issues.map((iss) => ({
                ...iss,
                path: iss.path ? [${k}, ...iss.path] : [${k}],
              }))
            );
          }
        } else if (${g}.value === undefined) {
          if (${k} in input) newResult[${k}] = undefined;
        } else {
          newResult[${k}] = ${g}.value;
        }
        `);
      } else {
        const g = R[$];
        f.write(`const ${g} = ${E($)};`), f.write(`
          if (${g}.issues.length) payload.issues = payload.issues.concat(${g}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${C($)}, ...iss.path] : [${C($)}]
          })));`), f.write(`newResult[${C($)}] = ${g}.value`);
      }
    f.write("payload.value = newResult;"), f.write("return payload;");
    const L = f.compile();
    return ($, g) => L(p, $, g);
  };
  let o;
  const u = ee, i = !Ne.jitless, a = i && rt.value, { catchall: h } = t;
  let _;
  e._zod.parse = (p, f) => {
    _ ?? (_ = n.value);
    const v = p.value;
    if (!u(v))
      return p.issues.push({
        expected: "object",
        code: "invalid_type",
        input: v,
        inst: e
      }), p;
    const y = [];
    if (i && a && (f == null ? void 0 : f.async) === !1 && f.jitless !== !0)
      o || (o = r(t.shape)), p = o(p, f);
    else {
      p.value = {};
      const g = _.shape;
      for (const k of _.keys) {
        const x = g[k], M = x._zod.run({ value: v[k], issues: [] }, f), ae = x._zod.optin === "optional" && x._zod.optout === "optional";
        M instanceof Promise ? y.push(M.then((le) => ae ? fe(le, p, k, v) : W(le, p, k))) : ae ? fe(M, p, k, v) : W(M, p, k);
      }
    }
    if (!h)
      return y.length ? Promise.all(y).then(() => p) : p;
    const E = [], R = _.keySet, L = h._zod, $ = L.def.type;
    for (const g of Object.keys(v)) {
      if (R.has(g))
        continue;
      if ($ === "never") {
        E.push(g);
        continue;
      }
      const k = L.run({ value: v[g], issues: [] }, f);
      k instanceof Promise ? y.push(k.then((x) => W(x, p, g))) : W(k, p, g);
    }
    return E.length && p.issues.push({
      code: "unrecognized_keys",
      keys: E,
      input: v,
      inst: e
    }), y.length ? Promise.all(y).then(() => p) : p;
  };
});
function de(e, t, n, r) {
  for (const o of e)
    if (o.issues.length === 0)
      return t.value = o.value, t;
  return t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((o) => o.issues.map((u) => O(u, r, P())))
  }), t;
}
const Dn = /* @__PURE__ */ c("$ZodUnion", (e, t) => {
  b.init(e, t), z(e._zod, "values", () => {
    if (t.options.every((n) => n._zod.values))
      return new Set(t.options.flatMap((n) => Array.from(n._zod.values)));
  }), z(e._zod, "pattern", () => {
    if (t.options.every((n) => n._zod.pattern)) {
      const n = t.options.map((r) => r._zod.pattern);
      return new RegExp(`^(${n.map((r) => ue(r.source)).join("|")})$`);
    }
  }), e._zod.parse = (n, r) => {
    let o = !1;
    const u = [];
    for (const i of t.options) {
      const s = i._zod.run({
        value: n.value,
        issues: []
      }, r);
      if (s instanceof Promise)
        u.push(s), o = !0;
      else {
        if (s.issues.length === 0)
          return s;
        u.push(s);
      }
    }
    return o ? Promise.all(u).then((i) => de(i, n, e, r)) : de(u, n, e, r);
  };
}), Un = /* @__PURE__ */ c("$ZodIntersection", (e, t) => {
  b.init(e, t), e._zod.parse = (n, r) => {
    const { value: o } = n, u = t.left._zod.run({ value: o, issues: [] }, r), i = t.right._zod.run({ value: o, issues: [] }, r);
    return u instanceof Promise || i instanceof Promise ? Promise.all([u, i]).then(([a, h]) => _e(n, a, h)) : _e(n, u, i);
  };
});
function ne(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (te(e) && te(t)) {
    const n = Object.keys(t), r = Object.keys(e).filter((u) => n.indexOf(u) !== -1), o = { ...e, ...t };
    for (const u of r) {
      const i = ne(e[u], t[u]);
      if (!i.valid)
        return {
          valid: !1,
          mergeErrorPath: [u, ...i.mergeErrorPath]
        };
      o[u] = i.data;
    }
    return { valid: !0, data: o };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let r = 0; r < e.length; r++) {
      const o = e[r], u = t[r], i = ne(o, u);
      if (!i.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...i.mergeErrorPath]
        };
      n.push(i.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function _e(e, t, n) {
  if (t.issues.length && e.issues.push(...t.issues), n.issues.length && e.issues.push(...n.issues), j(e))
    return e;
  const r = ne(t.value, n.value);
  if (!r.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(r.mergeErrorPath)}`);
  return e.value = r.data, e;
}
const Fn = /* @__PURE__ */ c("$ZodRecord", (e, t) => {
  b.init(e, t), e._zod.parse = (n, r) => {
    const o = n.value;
    if (!te(o))
      return n.issues.push({
        expected: "record",
        code: "invalid_type",
        input: o,
        inst: e
      }), n;
    const u = [];
    if (t.keyType._zod.values) {
      const i = t.keyType._zod.values;
      n.value = {};
      for (const a of i)
        if (typeof a == "string" || typeof a == "number" || typeof a == "symbol") {
          const h = t.valueType._zod.run({ value: o[a], issues: [] }, r);
          h instanceof Promise ? u.push(h.then((_) => {
            _.issues.length && n.issues.push(...N(a, _.issues)), n.value[a] = _.value;
          })) : (h.issues.length && n.issues.push(...N(a, h.issues)), n.value[a] = h.value);
        }
      let s;
      for (const a in o)
        i.has(a) || (s = s ?? [], s.push(a));
      s && s.length > 0 && n.issues.push({
        code: "unrecognized_keys",
        input: o,
        inst: e,
        keys: s
      });
    } else {
      n.value = {};
      for (const i of Reflect.ownKeys(o)) {
        if (i === "__proto__")
          continue;
        const s = t.keyType._zod.run({ value: i, issues: [] }, r);
        if (s instanceof Promise)
          throw new Error("Async schemas not supported in object keys currently");
        if (s.issues.length) {
          n.issues.push({
            origin: "record",
            code: "invalid_key",
            issues: s.issues.map((h) => O(h, r, P())),
            input: i,
            path: [i],
            inst: e
          }), n.value[s.value] = s.value;
          continue;
        }
        const a = t.valueType._zod.run({ value: o[i], issues: [] }, r);
        a instanceof Promise ? u.push(a.then((h) => {
          h.issues.length && n.issues.push(...N(i, h.issues)), n.value[s.value] = h.value;
        })) : (a.issues.length && n.issues.push(...N(i, a.issues)), n.value[s.value] = a.value);
      }
    }
    return u.length ? Promise.all(u).then(() => n) : n;
  };
}), Ln = /* @__PURE__ */ c("$ZodEnum", (e, t) => {
  b.init(e, t);
  const n = et(t.entries);
  e._zod.values = new Set(n), e._zod.pattern = new RegExp(`^(${n.filter((r) => ot.has(typeof r)).map((r) => typeof r == "string" ? Y(r) : r.toString()).join("|")})$`), e._zod.parse = (r, o) => {
    const u = r.value;
    return e._zod.values.has(u) || r.issues.push({
      code: "invalid_value",
      values: n,
      input: u,
      inst: e
    }), r;
  };
}), Mn = /* @__PURE__ */ c("$ZodTransform", (e, t) => {
  b.init(e, t), e._zod.parse = (n, r) => {
    const o = t.transform(n.value, n);
    if (r.async)
      return (o instanceof Promise ? o : Promise.resolve(o)).then((i) => (n.value = i, n));
    if (o instanceof Promise)
      throw new D();
    return n.value = o, n;
  };
}), Vn = /* @__PURE__ */ c("$ZodOptional", (e, t) => {
  b.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", z(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), z(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${ue(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, r) => n.value === void 0 ? n : t.innerType._zod.run(n, r);
}), Wn = /* @__PURE__ */ c("$ZodNullable", (e, t) => {
  b.init(e, t), z(e._zod, "optin", () => t.innerType._zod.optin), z(e._zod, "optout", () => t.innerType._zod.optout), z(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${ue(n.source)}|null)$`) : void 0;
  }), z(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, r) => n.value === null ? n : t.innerType._zod.run(n, r);
}), Bn = /* @__PURE__ */ c("$ZodDefault", (e, t) => {
  b.init(e, t), e._zod.optin = "optional", z(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((u) => me(u, t)) : me(o, t);
  };
});
function me(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const Gn = /* @__PURE__ */ c("$ZodPrefault", (e, t) => {
  b.init(e, t), e._zod.optin = "optional", z(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => (n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, r));
}), Kn = /* @__PURE__ */ c("$ZodNonOptional", (e, t) => {
  b.init(e, t), z(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((r) => r !== void 0)) : void 0;
  }), e._zod.parse = (n, r) => {
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((u) => ve(u, e)) : ve(o, e);
  };
});
function ve(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const Jn = /* @__PURE__ */ c("$ZodCatch", (e, t) => {
  b.init(e, t), z(e._zod, "optin", () => t.innerType._zod.optin), z(e._zod, "optout", () => t.innerType._zod.optout), z(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, r) => {
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then((u) => (n.value = u.value, u.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: u.issues.map((i) => O(i, r, P()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = o.value, o.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: o.issues.map((u) => O(u, r, P()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), Yn = /* @__PURE__ */ c("$ZodPipe", (e, t) => {
  b.init(e, t), z(e._zod, "values", () => t.in._zod.values), z(e._zod, "optin", () => t.in._zod.optin), z(e._zod, "optout", () => t.out._zod.optout), e._zod.parse = (n, r) => {
    const o = t.in._zod.run(n, r);
    return o instanceof Promise ? o.then((u) => ge(u, t, r)) : ge(o, t, r);
  };
});
function ge(e, t, n) {
  return j(e) ? e : t.out._zod.run({ value: e.value, issues: e.issues }, n);
}
const Xn = /* @__PURE__ */ c("$ZodReadonly", (e, t) => {
  b.init(e, t), z(e._zod, "propValues", () => t.innerType._zod.propValues), z(e._zod, "optin", () => t.innerType._zod.optin), z(e._zod, "optout", () => t.innerType._zod.optout), e._zod.parse = (n, r) => {
    const o = t.innerType._zod.run(n, r);
    return o instanceof Promise ? o.then(ze) : ze(o);
  };
});
function ze(e) {
  return e.value = Object.freeze(e.value), e;
}
const qn = /* @__PURE__ */ c("$ZodCustom", (e, t) => {
  I.init(e, t), b.init(e, t), e._zod.parse = (n, r) => n, e._zod.check = (n) => {
    const r = n.value, o = t.fn(r);
    if (o instanceof Promise)
      return o.then((u) => be(u, n, r, e));
    be(o, n, r, e);
  };
});
function be(e, t, n, r) {
  if (!e) {
    const o = {
      code: "custom",
      input: n,
      inst: r,
      // incorporates params.error into issue reporting
      path: [...r._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !r._zod.def.abort
      // params: inst._zod.def.params,
    };
    r._zod.def.params && (o.params = r._zod.def.params), t.issues.push(U(o));
  }
}
class Hn {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const r = n[0];
    if (this._map.set(t, r), r && typeof r == "object" && "id" in r) {
      if (this._idmap.has(r.id))
        throw new Error(`ID ${r.id} already exists in the registry`);
      this._idmap.set(r.id, t);
    }
    return this;
  }
  remove(t) {
    return this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const r = { ...this.get(n) ?? {} };
      return delete r.id, { ...r, ...this._map.get(t) };
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function Qn() {
  return new Hn();
}
const B = /* @__PURE__ */ Qn();
function er(e, t) {
  return new e({
    type: "string",
    ...l(t)
  });
}
function tr(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function we(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function nr(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function rr(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...l(t)
  });
}
function or(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...l(t)
  });
}
function ur(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...l(t)
  });
}
function ir(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function cr(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function sr(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function ar(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function lr(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function hr(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function pr(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function fr(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function dr(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function _r(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function mr(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function vr(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function gr(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function zr(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function br(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function wr(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...l(t)
  });
}
function Zr(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...l(t)
  });
}
function kr(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...l(t)
  });
}
function $r(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...l(t)
  });
}
function yr(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...l(t)
  });
}
function Ir(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...l(t)
  });
}
function Er(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...l(t)
  });
}
function Tr(e, t) {
  return new e({
    type: "boolean",
    ...l(t)
  });
}
function Pr(e) {
  return new e({
    type: "unknown"
  });
}
function Or(e, t) {
  return new e({
    type: "never",
    ...l(t)
  });
}
function Ze(e, t) {
  return new We({
    check: "less_than",
    ...l(t),
    value: e,
    inclusive: !1
  });
}
function H(e, t) {
  return new We({
    check: "less_than",
    ...l(t),
    value: e,
    inclusive: !0
  });
}
function ke(e, t) {
  return new Be({
    check: "greater_than",
    ...l(t),
    value: e,
    inclusive: !1
  });
}
function Q(e, t) {
  return new Be({
    check: "greater_than",
    ...l(t),
    value: e,
    inclusive: !0
  });
}
function $e(e, t) {
  return new Gt({
    check: "multiple_of",
    ...l(t),
    value: e
  });
}
function Je(e, t) {
  return new Jt({
    check: "max_length",
    ...l(t),
    maximum: e
  });
}
function K(e, t) {
  return new Yt({
    check: "min_length",
    ...l(t),
    minimum: e
  });
}
function Ye(e, t) {
  return new Xt({
    check: "length_equals",
    ...l(t),
    length: e
  });
}
function Nr(e, t) {
  return new qt({
    check: "string_format",
    format: "regex",
    ...l(t),
    pattern: e
  });
}
function Sr(e) {
  return new Ht({
    check: "string_format",
    format: "lowercase",
    ...l(e)
  });
}
function Ar(e) {
  return new Qt({
    check: "string_format",
    format: "uppercase",
    ...l(e)
  });
}
function Rr(e, t) {
  return new en({
    check: "string_format",
    format: "includes",
    ...l(t),
    includes: e
  });
}
function xr(e, t) {
  return new tn({
    check: "string_format",
    format: "starts_with",
    ...l(t),
    prefix: e
  });
}
function Cr(e, t) {
  return new nn({
    check: "string_format",
    format: "ends_with",
    ...l(t),
    suffix: e
  });
}
function F(e) {
  return new rn({
    check: "overwrite",
    tx: e
  });
}
function jr(e) {
  return F((t) => t.normalize(e));
}
function Dr() {
  return F((e) => e.trim());
}
function Ur() {
  return F((e) => e.toLowerCase());
}
function Fr() {
  return F((e) => e.toUpperCase());
}
function Lr(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...l(n)
  });
}
function Mr(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...l(n)
  });
}
const Vr = /* @__PURE__ */ c("ZodISODateTime", (e, t) => {
  gn.init(e, t), w.init(e, t);
});
function Wr(e) {
  return Zr(Vr, e);
}
const Br = /* @__PURE__ */ c("ZodISODate", (e, t) => {
  zn.init(e, t), w.init(e, t);
});
function Gr(e) {
  return kr(Br, e);
}
const Kr = /* @__PURE__ */ c("ZodISOTime", (e, t) => {
  bn.init(e, t), w.init(e, t);
});
function Jr(e) {
  return $r(Kr, e);
}
const Yr = /* @__PURE__ */ c("ZodISODuration", (e, t) => {
  wn.init(e, t), w.init(e, t);
});
function Xr(e) {
  return yr(Yr, e);
}
const qr = (e, t) => {
  Ce.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => dt(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => ft(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => e.issues.push(n)
      // enumerable: false,
    },
    addIssues: {
      value: (n) => e.issues.push(...n)
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, q = c("ZodError", qr, {
  Parent: Error
}), Hr = /* @__PURE__ */ _t(q), Qr = /* @__PURE__ */ mt(q), eo = /* @__PURE__ */ De(q), to = /* @__PURE__ */ Ue(q), Z = /* @__PURE__ */ c("ZodType", (e, t) => (b.init(e, t), e.def = t, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(
  {
    ...t,
    checks: [
      ...t.checks ?? [],
      ...n.map((r) => typeof r == "function" ? { _zod: { check: r, def: { check: "custom" }, onattach: [] } } : r)
    ]
  }
  // { parent: true }
), e.clone = (n, r) => S(e, n, r), e.brand = () => e, e.register = (n, r) => (n.add(e, r), e), e.parse = (n, r) => Hr(e, n, r, { callee: e.parse }), e.safeParse = (n, r) => eo(e, n, r), e.parseAsync = async (n, r) => Qr(e, n, r, { callee: e.parseAsync }), e.safeParseAsync = async (n, r) => to(e, n, r), e.spa = e.safeParseAsync, e.refine = (n, r) => e.check(qo(n, r)), e.superRefine = (n) => e.check(Ho(n)), e.overwrite = (n) => e.check(F(n)), e.optional = () => Te(e), e.nullable = () => Pe(e), e.nullish = () => Te(Pe(e)), e.nonoptional = (n) => Vo(e, n), e.array = () => A(e), e.or = (n) => Oo([e, n]), e.and = (n) => So(e, n), e.transform = (n) => Oe(e, jo(n)), e.default = (n) => Fo(e, n), e.prefault = (n) => Mo(e, n), e.catch = (n) => Bo(e, n), e.pipe = (n) => Oe(e, n), e.readonly = () => Jo(e), e.describe = (n) => {
  const r = e.clone();
  return B.add(r, { description: n }), r;
}, Object.defineProperty(e, "description", {
  get() {
    var n;
    return (n = B.get(e)) == null ? void 0 : n.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return B.get(e);
  const r = e.clone();
  return B.add(r, n[0]), r;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e)), Xe = /* @__PURE__ */ c("_ZodString", (e, t) => {
  se.init(e, t), Z.init(e, t);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...r) => e.check(Nr(...r)), e.includes = (...r) => e.check(Rr(...r)), e.startsWith = (...r) => e.check(xr(...r)), e.endsWith = (...r) => e.check(Cr(...r)), e.min = (...r) => e.check(K(...r)), e.max = (...r) => e.check(Je(...r)), e.length = (...r) => e.check(Ye(...r)), e.nonempty = (...r) => e.check(K(1, ...r)), e.lowercase = (r) => e.check(Sr(r)), e.uppercase = (r) => e.check(Ar(r)), e.trim = () => e.check(Dr()), e.normalize = (...r) => e.check(jr(...r)), e.toLowerCase = () => e.check(Ur()), e.toUpperCase = () => e.check(Fr());
}), no = /* @__PURE__ */ c("ZodString", (e, t) => {
  se.init(e, t), Xe.init(e, t), e.email = (n) => e.check(tr(ro, n)), e.url = (n) => e.check(ir(oo, n)), e.jwt = (n) => e.check(wr(bo, n)), e.emoji = (n) => e.check(cr(uo, n)), e.guid = (n) => e.check(we(ye, n)), e.uuid = (n) => e.check(nr(G, n)), e.uuidv4 = (n) => e.check(rr(G, n)), e.uuidv6 = (n) => e.check(or(G, n)), e.uuidv7 = (n) => e.check(ur(G, n)), e.nanoid = (n) => e.check(sr(io, n)), e.guid = (n) => e.check(we(ye, n)), e.cuid = (n) => e.check(ar(co, n)), e.cuid2 = (n) => e.check(lr(so, n)), e.ulid = (n) => e.check(hr(ao, n)), e.base64 = (n) => e.check(gr(vo, n)), e.base64url = (n) => e.check(zr(go, n)), e.xid = (n) => e.check(pr(lo, n)), e.ksuid = (n) => e.check(fr(ho, n)), e.ipv4 = (n) => e.check(dr(po, n)), e.ipv6 = (n) => e.check(_r(fo, n)), e.cidrv4 = (n) => e.check(mr(_o, n)), e.cidrv6 = (n) => e.check(vr(mo, n)), e.e164 = (n) => e.check(br(zo, n)), e.datetime = (n) => e.check(Wr(n)), e.date = (n) => e.check(Gr(n)), e.time = (n) => e.check(Jr(n)), e.duration = (n) => e.check(Xr(n));
});
function d(e) {
  return er(no, e);
}
const w = /* @__PURE__ */ c("ZodStringFormat", (e, t) => {
  m.init(e, t), Xe.init(e, t);
}), ro = /* @__PURE__ */ c("ZodEmail", (e, t) => {
  an.init(e, t), w.init(e, t);
}), ye = /* @__PURE__ */ c("ZodGUID", (e, t) => {
  cn.init(e, t), w.init(e, t);
}), G = /* @__PURE__ */ c("ZodUUID", (e, t) => {
  sn.init(e, t), w.init(e, t);
}), oo = /* @__PURE__ */ c("ZodURL", (e, t) => {
  ln.init(e, t), w.init(e, t);
}), uo = /* @__PURE__ */ c("ZodEmoji", (e, t) => {
  hn.init(e, t), w.init(e, t);
}), io = /* @__PURE__ */ c("ZodNanoID", (e, t) => {
  pn.init(e, t), w.init(e, t);
}), co = /* @__PURE__ */ c("ZodCUID", (e, t) => {
  fn.init(e, t), w.init(e, t);
}), so = /* @__PURE__ */ c("ZodCUID2", (e, t) => {
  dn.init(e, t), w.init(e, t);
}), ao = /* @__PURE__ */ c("ZodULID", (e, t) => {
  _n.init(e, t), w.init(e, t);
}), lo = /* @__PURE__ */ c("ZodXID", (e, t) => {
  mn.init(e, t), w.init(e, t);
}), ho = /* @__PURE__ */ c("ZodKSUID", (e, t) => {
  vn.init(e, t), w.init(e, t);
}), po = /* @__PURE__ */ c("ZodIPv4", (e, t) => {
  Zn.init(e, t), w.init(e, t);
}), fo = /* @__PURE__ */ c("ZodIPv6", (e, t) => {
  kn.init(e, t), w.init(e, t);
}), _o = /* @__PURE__ */ c("ZodCIDRv4", (e, t) => {
  $n.init(e, t), w.init(e, t);
}), mo = /* @__PURE__ */ c("ZodCIDRv6", (e, t) => {
  yn.init(e, t), w.init(e, t);
}), vo = /* @__PURE__ */ c("ZodBase64", (e, t) => {
  In.init(e, t), w.init(e, t);
}), go = /* @__PURE__ */ c("ZodBase64URL", (e, t) => {
  Tn.init(e, t), w.init(e, t);
}), zo = /* @__PURE__ */ c("ZodE164", (e, t) => {
  Pn.init(e, t), w.init(e, t);
}), bo = /* @__PURE__ */ c("ZodJWT", (e, t) => {
  Nn.init(e, t), w.init(e, t);
}), qe = /* @__PURE__ */ c("ZodNumber", (e, t) => {
  Ke.init(e, t), Z.init(e, t), e.gt = (r, o) => e.check(ke(r, o)), e.gte = (r, o) => e.check(Q(r, o)), e.min = (r, o) => e.check(Q(r, o)), e.lt = (r, o) => e.check(Ze(r, o)), e.lte = (r, o) => e.check(H(r, o)), e.max = (r, o) => e.check(H(r, o)), e.int = (r) => e.check(Ie(r)), e.safe = (r) => e.check(Ie(r)), e.positive = (r) => e.check(ke(0, r)), e.nonnegative = (r) => e.check(Q(0, r)), e.negative = (r) => e.check(Ze(0, r)), e.nonpositive = (r) => e.check(H(0, r)), e.multipleOf = (r, o) => e.check($e(r, o)), e.step = (r, o) => e.check($e(r, o)), e.finite = () => e;
  const n = e._zod.bag;
  e.minValue = Math.max(n.minimum ?? Number.NEGATIVE_INFINITY, n.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(n.maximum ?? Number.POSITIVE_INFINITY, n.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? 0.5), e.isFinite = !0, e.format = n.format ?? null;
});
function wo(e) {
  return Ir(qe, e);
}
const Zo = /* @__PURE__ */ c("ZodNumberFormat", (e, t) => {
  Sn.init(e, t), qe.init(e, t);
});
function Ie(e) {
  return Er(Zo, e);
}
const ko = /* @__PURE__ */ c("ZodBoolean", (e, t) => {
  An.init(e, t), Z.init(e, t);
});
function J(e) {
  return Tr(ko, e);
}
const $o = /* @__PURE__ */ c("ZodUnknown", (e, t) => {
  Rn.init(e, t), Z.init(e, t);
});
function Ee() {
  return Pr($o);
}
const yo = /* @__PURE__ */ c("ZodNever", (e, t) => {
  xn.init(e, t), Z.init(e, t);
});
function Io(e) {
  return Or(yo, e);
}
const Eo = /* @__PURE__ */ c("ZodArray", (e, t) => {
  Cn.init(e, t), Z.init(e, t), e.element = t.element, e.min = (n, r) => e.check(K(n, r)), e.nonempty = (n) => e.check(K(1, n)), e.max = (n, r) => e.check(Je(n, r)), e.length = (n, r) => e.check(Ye(n, r)), e.unwrap = () => e.element;
});
function A(e, t) {
  return Lr(Eo, e, t);
}
const To = /* @__PURE__ */ c("ZodObject", (e, t) => {
  jn.init(e, t), Z.init(e, t), z(e, "shape", () => t.shape), e.keyof = () => xo(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Ee() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Ee() }), e.strict = () => e.clone({ ...e._zod.def, catchall: Io() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => at(e, n), e.merge = (n) => lt(e, n), e.pick = (n) => ct(e, n), e.omit = (n) => st(e, n), e.partial = (...n) => ht(He, e, n[0]), e.required = (...n) => pt(Qe, e, n[0]);
});
function T(e, t) {
  const n = {
    type: "object",
    get shape() {
      return ie(this, "shape", { ...e }), this.shape;
    },
    ...l(t)
  };
  return new To(n);
}
const Po = /* @__PURE__ */ c("ZodUnion", (e, t) => {
  Dn.init(e, t), Z.init(e, t), e.options = t.options;
});
function Oo(e, t) {
  return new Po({
    type: "union",
    options: e,
    ...l(t)
  });
}
const No = /* @__PURE__ */ c("ZodIntersection", (e, t) => {
  Un.init(e, t), Z.init(e, t);
});
function So(e, t) {
  return new No({
    type: "intersection",
    left: e,
    right: t
  });
}
const Ao = /* @__PURE__ */ c("ZodRecord", (e, t) => {
  Fn.init(e, t), Z.init(e, t), e.keyType = t.keyType, e.valueType = t.valueType;
});
function Ro(e, t, n) {
  return new Ao({
    type: "record",
    keyType: e,
    valueType: t,
    ...l(n)
  });
}
const re = /* @__PURE__ */ c("ZodEnum", (e, t) => {
  Ln.init(e, t), Z.init(e, t), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (r, o) => {
    const u = {};
    for (const i of r)
      if (n.has(i))
        u[i] = t.entries[i];
      else
        throw new Error(`Key ${i} not found in enum`);
    return new re({
      ...t,
      checks: [],
      ...l(o),
      entries: u
    });
  }, e.exclude = (r, o) => {
    const u = { ...t.entries };
    for (const i of r)
      if (n.has(i))
        delete u[i];
      else
        throw new Error(`Key ${i} not found in enum`);
    return new re({
      ...t,
      checks: [],
      ...l(o),
      entries: u
    });
  };
});
function xo(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((r) => [r, r])) : e;
  return new re({
    type: "enum",
    entries: n,
    ...l(t)
  });
}
const Co = /* @__PURE__ */ c("ZodTransform", (e, t) => {
  Mn.init(e, t), Z.init(e, t), e._zod.parse = (n, r) => {
    n.addIssue = (u) => {
      if (typeof u == "string")
        n.issues.push(U(u, n.value, t));
      else {
        const i = u;
        i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = n.value), i.inst ?? (i.inst = e), i.continue ?? (i.continue = !0), n.issues.push(U(i));
      }
    };
    const o = t.transform(n.value, n);
    return o instanceof Promise ? o.then((u) => (n.value = u, n)) : (n.value = o, n);
  };
});
function jo(e) {
  return new Co({
    type: "transform",
    transform: e
  });
}
const He = /* @__PURE__ */ c("ZodOptional", (e, t) => {
  Vn.init(e, t), Z.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Te(e) {
  return new He({
    type: "optional",
    innerType: e
  });
}
const Do = /* @__PURE__ */ c("ZodNullable", (e, t) => {
  Wn.init(e, t), Z.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Pe(e) {
  return new Do({
    type: "nullable",
    innerType: e
  });
}
const Uo = /* @__PURE__ */ c("ZodDefault", (e, t) => {
  Bn.init(e, t), Z.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Fo(e, t) {
  return new Uo({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : t;
    }
  });
}
const Lo = /* @__PURE__ */ c("ZodPrefault", (e, t) => {
  Gn.init(e, t), Z.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Mo(e, t) {
  return new Lo({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : t;
    }
  });
}
const Qe = /* @__PURE__ */ c("ZodNonOptional", (e, t) => {
  Kn.init(e, t), Z.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Vo(e, t) {
  return new Qe({
    type: "nonoptional",
    innerType: e,
    ...l(t)
  });
}
const Wo = /* @__PURE__ */ c("ZodCatch", (e, t) => {
  Jn.init(e, t), Z.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Bo(e, t) {
  return new Wo({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const Go = /* @__PURE__ */ c("ZodPipe", (e, t) => {
  Yn.init(e, t), Z.init(e, t), e.in = t.in, e.out = t.out;
});
function Oe(e, t) {
  return new Go({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const Ko = /* @__PURE__ */ c("ZodReadonly", (e, t) => {
  Xn.init(e, t), Z.init(e, t);
});
function Jo(e) {
  return new Ko({
    type: "readonly",
    innerType: e
  });
}
const Yo = /* @__PURE__ */ c("ZodCustom", (e, t) => {
  qn.init(e, t), Z.init(e, t);
});
function Xo(e, t) {
  const n = new I({
    check: "custom",
    ...l(t)
  });
  return n._zod.check = e, n;
}
function qo(e, t = {}) {
  return Mr(Yo, e, t);
}
function Ho(e, t) {
  const n = Xo((r) => (r.addIssue = (o) => {
    if (typeof o == "string")
      r.issues.push(U(o, r.value, n._zod.def));
    else {
      const u = o;
      u.fatal && (u.continue = !1), u.code ?? (u.code = "custom"), u.input ?? (u.input = r.value), u.inst ?? (u.inst = n), u.continue ?? (u.continue = !n._zod.def.abort), r.issues.push(U(u));
    }
  }, e(r.value, r)), t);
  return n;
}
const Qo = T({
  value: d(),
  label: d(),
  hierarchical: J(),
  publicly_queryable: J()
}), eu = T({
  countries: Ro(d(), d()),
  currency: T({
    slug: d(),
    symbol: d()
  }),
  product_taxonomies: A(Qo),
  notify_low_stock_amount: wo(),
  dimension_unit: d(),
  weight_unit: d(),
  permalinks: T({
    product_base: d(),
    category_base: d(),
    tag_base: d(),
    attribute_base: d(),
    use_verbose_page_rules: J(),
    product_rewrite_slug: d(),
    category_rewrite_slug: d(),
    tag_rewrite_slug: d(),
    attribute_rewrite_slug: d()
  }),
  manage_stock: J(),
  product_types: A(T({
    value: d(),
    label: d(),
    color: d()
  })),
  order_statuses: A(T({
    value: d(),
    label: d(),
    color: d()
  })),
  post_statuses: A(T({
    value: d(),
    label: d(),
    color: d()
  })),
  product_stock_statuses: A(T({
    value: d(),
    label: d(),
    color: d()
  }))
}), tu = {
  countries: {},
  currency: {
    slug: "",
    symbol: ""
  },
  product_taxonomies: [],
  notify_low_stock_amount: 0,
  dimension_unit: "",
  weight_unit: "",
  permalinks: {
    product_base: "",
    category_base: "",
    tag_base: "",
    attribute_base: "",
    use_verbose_page_rules: !1,
    product_rewrite_slug: "",
    category_rewrite_slug: "",
    tag_rewrite_slug: "",
    attribute_rewrite_slug: ""
  },
  manage_stock: !0,
  product_types: [],
  order_statuses: [],
  post_statuses: [],
  product_stock_statuses: []
};
export {
  tu as DEFAULT_WOOCOMMERCE,
  Qo as TaxonomySchema,
  eu as WoocommerceSchema
};
